import React from 'react'
import PropTypes from 'prop-types'

import { polyglot } from '../../../index'

import PanelWithContent from '../PanelWithContent/PanelWithContent'
import { Button } from '../Button/Button'

export default class StagedFormInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      progressPercentage: '0%',
      formsNumber: undefined,
      currentForm: 0
    }
    this.renderForms = this.renderForms.bind(this)
    this.nextForm = this.nextForm.bind(this)
    this.prevForm = this.prevForm.bind(this)
    this.dataSendWarning = this.dataSendWarning.bind(this)
    this.getFillmentPercentage = this.getFillmentPercentage.bind(this)
  }

  componentWillMount () {
    this.setState({
      formsNumber: this.props.data.length
    })
  }

  getFillmentPercentage () {
    const percentage = Math.floor(1 / (this.state.formsNumber) * 100) || 0
    let result = `${percentage}%`
    if (this.state.formsNumber && this.state.currentForm) {
      const size = percentage * (this.state.currentForm + 1)
      result = `${size}%`
    }
    return result
  }

  savePanelData (data, key) {
    this.props.handleDataSubmit(data, key)
  }

  renderForms () {
    if (this.props.data) {
      const element = this.props.data[this.state.currentForm]
      return <PanelWithContent
        expandInputFields={this.props.expandInputFields}
        handleChange={this.props.handleDataChange}
        extraFieldContent={element.extraFieldContent}
        saveData={this.savePanelData.bind(this)}
        dataSendWarning={this.dataSendWarning}
        key={element.key}
        savedData={this.props.savedData[element.key]}
        dataKey={element.key}
        title={element.title}
        fields={element.fields}
        extraFieldEnabled={element['isExtraFieldEnabled']} />
    }
  }

  nextForm () {
    this.setState({
      currentForm: this.state.currentForm + 1
    })
  }

  prevForm () {
    this.setState({
      currentForm: this.state.currentForm - 1
    })
  }

  getRedirectLink () {
    return this.props.redirectTo
  }

  isNextDisabled () {
    return this.state.currentForm + 1 >= this.state.formsNumber
  }

  isPreviousDisabled () {
    return this.state.currentForm - 1 < 0
  }

  dataSendWarning () {
    if (!(this.state.currentForm + 1 >= this.state.formsNumber)) {
      this.nextForm()
    } else {
      this.setState({
        redirect: true
      })
    }
  }

  render () {
    if (this.state.redirect && this.props.redirectTo) {
      this.props.redirectTo()
      this.setState({redirect: false})
      return null
    }
    return <div className='container-fluid'>
      <div className='col-xs-12'>
        <div className='progress'>
          <div className='progress-bar' role='progressbar' aria-valuemin='0' aria-valuemax='100' style={{minWidth: '2em', width: this.getFillmentPercentage()}}>
            {this.getFillmentPercentage()}
          </div>
        </div>
      </div>
      <div className='col-xs-12' style={{marginBottom: '20px'}}>
        <Button text={polyglot.t('staticFields.commonFields.previous')} buttonType='btn-primary pull-left' disabled={this.isPreviousDisabled()} type='button' onClick={this.prevForm} />
        <Button text={polyglot.t('staticFields.commonFields.next')} buttonType='btn-primary pull-right' disabled={this.isNextDisabled()} type='button' onClick={this.nextForm} />
      </div>
      <div className='col-xs-12'>
        {this.renderForms()}
      </div>
    </div>
  }
}

StagedFormInput.propTypes = {
  handleDataSubmit: PropTypes.func.isRequired,
  handleDataChange: PropTypes.func,
  savedData: PropTypes.object,
  data: PropTypes.array.isRequired,
  redirectTo: PropTypes.func,
  expandInputFields: PropTypes.bool.isRequired
}

StagedFormInput.defaultProps = {
  expandInputFields: false
}



// WEBPACK FOOTER //
// ./src/components/common/StagedFormInput/StagedFormInput.js